/* Generated by scripts/generate-process-vocabulary.mjs from ../schema/process-vocabulary.schema.json. Do not edit; regenerate. */

export const processVocabulary = {
  "literalTypes": [
    "http://www.w3.org/2001/XMLSchema#boolean",
    "http://www.w3.org/2001/XMLSchema#decimal",
    "http://www.w3.org/2001/XMLSchema#integer",
    "http://www.w3.org/2001/XMLSchema#string"
  ],
  "namespace": "https://w3id.org/hisqu/dmw/process#",
  "terms": [
    "AbstractStep",
    "AcceptResultsWorkflow",
    "Accepted",
    "Active",
    "AgentRoute",
    "AgentStepDefinition",
    "Annotation",
    "AnnotationSet",
    "ApiKeyRoute",
    "Artifact",
    "AttachmentState",
    "AutomaticStart",
    "BaseType",
    "Binding",
    "Bindings",
    "BuiltInTool",
    "CapabilityOverrides",
    "CapabilityRequirement",
    "ChangeSet",
    "ChangeSetMergedCondition",
    "CheckPassesCondition",
    "CheckReport",
    "ChoiceMadeCondition",
    "ChoiceResponse",
    "CompetencyQuestion",
    "ContentVersion",
    "Corpus",
    "CorpusEntry",
    "CorpusImport",
    "CorpusWork",
    "Data",
    "DecideResultsResponse",
    "DefinitionBinding",
    "Deprecated",
    "DerivedData",
    "DerivedRecords",
    "Document",
    "Draft",
    "DraftQuestionsWorkflow",
    "EditItemWorkflow",
    "ExtractionResult",
    "FewShotExample",
    "HtmlPage",
    "HumanStepDefinition",
    "ImportMode",
    "InputStep",
    "IsolatedSession",
    "Item",
    "ItemVersion",
    "KeepMemoryResponse",
    "KeepMemoryWorkflow",
    "KnowledgeDataWork",
    "LabelList",
    "Library",
    "LifecycleState",
    "LlmRoute",
    "MainStep",
    "Memory",
    "MemoryWork",
    "Module",
    "OntologyModule",
    "OntologySlice",
    "OntologyWork",
    "OutcomeCondition",
    "Parameter",
    "PresentDocumentsWorkflow",
    "ProcessWork",
    "Project",
    "Prompt",
    "ProposeChangeResponse",
    "Proposed",
    "RankedReference",
    "RecordedResult",
    "Release",
    "ReleasePartResponse",
    "ReleaseRequest",
    "ReplaceAllImport",
    "ResponseKind",
    "Retired",
    "ReviewChangeSetResponse",
    "ReviewMemoriesWorkflow",
    "ReviewMemoryResponse",
    "ReviewOutputResponse",
    "ReviewResponseKind",
    "Role",
    "Segment",
    "SessionMode",
    "ShapesGraph",
    "Skill",
    "SourceVersion",
    "StartMode",
    "StartOnRequest",
    "StepDefinition",
    "StepRole",
    "TalkStepDefinition",
    "TermCard",
    "TextResponse",
    "TextUnit",
    "ThreadSession",
    "Tool",
    "ToolStepDefinition",
    "TypeAlternative",
    "UpsertImport",
    "Withdrawn",
    "WorkArea",
    "Workflow",
    "WorkflowStep",
    "WorkspaceFile",
    "WorkspaceFileResponse",
    "abstract",
    "acceptsDefinition",
    "binds",
    "bindsAbstractStep",
    "bindsDefinition",
    "bindsItem",
    "bindsRole",
    "bindsWorkflow",
    "contentDigest",
    "dependsOn",
    "destination",
    "developmentStage",
    "expectedChoice",
    "exports",
    "hasCurator",
    "hasDefinitionBinding",
    "hasSlot",
    "holds",
    "importMode",
    "inModule",
    "involvesLlm",
    "key",
    "lifecycle",
    "lifecycleReason",
    "literalType",
    "modelUse",
    "needsPersonInput",
    "noReplacement",
    "offersTalk",
    "outcomeCondition",
    "pins",
    "proposes",
    "proposesOutput",
    "proven",
    "readsOutput",
    "requiresCapability",
    "reservedFor",
    "responseKind",
    "runsWith",
    "segmentType",
    "selectorKind",
    "selectorVersion",
    "sessionMode",
    "startMode",
    "stepRole",
    "toolParameter",
    "touchedIn",
    "typeAlternative",
    "usesAgentInstructions",
    "usesBuiltInTool",
    "usesDefinition",
    "usesPrompt",
    "usesSkill",
    "usesTool",
    "valueType",
    "versionOf"
  ],
  "version": "1.2.0-dev"
} as const;

/** A term the ontology declares, by its local name. */
export type ProcessTerm = (typeof processVocabulary.terms)[number];
